import {
  INTERCOM_REQUEST_TYPE,
  INTERCOM_DATA_EVENT,
  INTERCOM_DATA_EVENT_NAME,
  INTERCOM_DATA_EVENT_ID,
  INTERCOM_DATA_EVENT_USER_ID,
  INTERCOM_DATA_EVENT_USER_EMAIL,
  INTERCOM_DATA_EVENT_METADATA,
  INTERCOM_TICKET_CREATION,
  INTERCOM_TICKET_TYPE_ID,
  INTERCOM_TICKET_CONTACTS,
  INTERCOM_TICKET_TICKET_ATTRIBUTES,
  INTERCOM_ADMIN_ID,
} from "@avenueops/shared-types";

export function getIntercomFieldDescription(fullFieldName: string): JSX.Element | null {
  return (
    <>
      {fullFieldName === INTERCOM_REQUEST_TYPE ? (
        <span>Specify whether Avenue should emit a data event or create a new Intercom ticket</span>
      ) : fullFieldName === INTERCOM_ADMIN_ID ? (
        <span>
          Fallback to be used in situations when Avenue cannot find an Intercom admin for operations such as ticket note creator, etc. For most cases, Avenue
          will be able to determine an Intercom <code>admin_id</code> using an Avenue user's email address.
        </span>
      ) : fullFieldName === INTERCOM_DATA_EVENT ? (
        <div className="flex flex-row gap-x-1">
          <span>
            For use with <strong>Data Event</strong> request only. See{" "}
            <strong>
              <a href="https://developers.intercom.com/intercom-api-reference/reference/createdataevent"> these docs</a>
            </strong>{" "}
            for more info regarding supported fields. The <code>created_at</code> field will be supplied by Avenue.
          </span>
        </div>
      ) : fullFieldName === INTERCOM_DATA_EVENT_NAME ? (
        <div className="flex flex-row gap-x-1">
          <span>The name of the event that occurred.</span>
        </div>
      ) : fullFieldName === INTERCOM_DATA_EVENT_ID ? (
        <div className="flex flex-row gap-x-1">
          <span>Your identifier for a lead or a user.</span>
        </div>
      ) : fullFieldName === INTERCOM_DATA_EVENT_USER_ID ? (
        <div className="flex flex-row gap-x-1">
          <span>Your identifier for the user.</span>
        </div>
      ) : fullFieldName === INTERCOM_DATA_EVENT_USER_EMAIL ? (
        <div className="flex flex-row gap-x-1">
          <span>An email address for your user. An email should only be used where your application uses email to uniquely identify users.</span>
        </div>
      ) : fullFieldName === INTERCOM_DATA_EVENT_METADATA ? (
        <div className="flex flex-row gap-x-1">
          <span>
            Optional metadata about the <strong>Data Event</strong>.
          </span>
        </div>
      ) : fullFieldName === INTERCOM_TICKET_CREATION ? (
        <div className="flex flex-row gap-x-1">
          <span>
            For use with <strong>Ticket Creation</strong> request only. See{" "}
            <strong>
              <a href="https://developers.intercom.com/intercom-api-reference/v0/reference/post_tickets"> these docs</a>
            </strong>{" "}
            for more info regarding supported fields.
          </span>
        </div>
      ) : fullFieldName === INTERCOM_TICKET_TYPE_ID ? (
        <div className="flex flex-row gap-x-1">
          <span>The ID of the type of ticket you want to create</span>
        </div>
      ) : fullFieldName === INTERCOM_TICKET_CONTACTS ? (
        <div className="flex flex-row gap-x-1">
          <span>The list of contacts (users or leads) affected by this ticket. Currently only one is allowed</span>
        </div>
      ) : fullFieldName === INTERCOM_TICKET_TICKET_ATTRIBUTES ? (
        <div className="flex flex-row gap-x-1">
          <span>
            The custom attributes set on the ticket. For the default title and description attributes, the keys are <code>_default_title_</code> and{" "}
            <code>_default_description_</code>
          </span>
        </div>
      ) : null}
    </>
  );
}
